// extracted by mini-css-extract-plugin
export var tosLink = "_ay-0";